module.exports = __webpack_public_path__ + "static/media/Latest_News_m_mr.e94b2115.jpg";